
import React from 'react';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import './styles/stepCard.css'

export default function StepCard({ activeStep, steps }) {
  return (
    <Stepper activeStep={activeStep} >
      {steps.map((label, index) => {
        // Determine dynamic class for step
        let stepClass = 'step-label';
        if (index === activeStep) stepClass += ' step-active';
        else if (index < activeStep) stepClass += ' step-completed';

        return (
          <Step key={label}>
            <StepLabel className={stepClass}>{label}</StepLabel>
          </Step>
        );
      })}
    </Stepper>
  );
}

